import { render, staticRenderFns } from "./problemList.vue?vue&type=template&id=6886c8cc&scoped=true"
import script from "./problemList.vue?vue&type=script&lang=js"
export * from "./problemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6886c8cc",
  null
  
)

export default component.exports